import { delayOffset, intersectionWatcher } from "@/lib/animation";

const selectors = {
  titleFirst: ".animation--container.animation--order-1 > *",
  titleSecond: ".animation--container.animation--order-2 > *",
  imageFirst: ".animation--item.animation--order-1",
  imageSecond: ".animation--item.animation--order-2",
  items: ".animation--item:not(.animation--order-1, .animation--order-2)",
  animationContainers: ".animation--container",
  animationItems: ".animation--item"
};

export default node => {
  const delayItems = [
    selectors.titleFirst,
    selectors.imageFirst,
    selectors.titleSecond,
    selectors.imageSecond,
    selectors.items
  ];

  // Add the animation delay offset variables
  delayOffset(node, delayItems);

  const observer = intersectionWatcher(node);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
